// Thin wrapper around notistack. Consumers never import notistack directly.
import { useSnackbar } from 'notistack';

const DURATIONS = {
  success: 3000,
  error: 6000,
  warning: 5000,
  info: 4000,
};

export function useToast() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const toast = {
    success: (message, options = {}) =>
      enqueueSnackbar(message, { variant: 'success', autoHideDuration: DURATIONS.success, ...options }),
    error: (message, options = {}) =>
      enqueueSnackbar(message, { variant: 'error', autoHideDuration: DURATIONS.error, ...options }),
    warning: (message, options = {}) =>
      enqueueSnackbar(message, { variant: 'warning', autoHideDuration: DURATIONS.warning, ...options }),
    info: (message, options = {}) =>
      enqueueSnackbar(message, { variant: 'info', autoHideDuration: DURATIONS.info, ...options }),
    dismiss: closeSnackbar,
  };

  return toast;
}
